import React from "react";
import "./ImageSideIQComponent.scss";
import Frame1 from "../../assets/icons/iq-img1-w.png";
import Frame2 from "../../assets/icons/iq-img2-w.png";
import Frame3 from "../../assets/icons/iq-img3-w.png";
import TickDot from "../../assets/icons/tick-dot.png";
import { Col, Row } from "react-bootstrap";

const ImageSideIQComponent = () => {
  return (
    <>
      <Row className="frame-row row-marging-bt ">
        <Col md={6}>
          <img src={Frame1} alt={"Frame1"} className="frame-img" />
        </Col>
        <Col md={6} className="frame-text-col mg-40">
          <div className="frame-header">Save Booking Acquisition Time:</div>
          <div className="frame-content pd-right">
            <img src={TickDot} alt="point" className="tick-dot" />
            <p className="frame-text">
              Quotes and operators&rsquo; entire fleet in 2-3 seconds at 99%
              accuracy
            </p>
          </div>
          <div className="frame-content pd-right">
            <img src={TickDot} alt="point" className="tick-dot" />
            <p className="frame-text">
              Automates - &lsquo;manual booking decisions&rsquo; through
              proprietary technology
            </p>
          </div>
          <div className="frame-content pd-right">
            <img src={TickDot} alt="point" className="tick-dot" />
            <p className="frame-text">Saves operators quoting time, by 99%+</p>
          </div>
        </Col>
      </Row>
      <Row className="frame-row row-marging-bt ">
        <Col md={6} className="left-image">
          <img src={Frame2} alt={"Frame1"} className="frame-img" />
        </Col>
        <Col md={6} className="mg-40">
          <div className="frame-header">
            Elegant Consumer Facing Booking Platform
          </div>
          <div className="frame-content pd-left">
            <img src={TickDot} alt="point" className="tick-dot" />
            <p className="frame-text">Proven UI/UX engages your customer</p>
          </div>
          <div className="frame-content pd-left">
            <img src={TickDot} alt="point" className="tick-dot" />
            <p className="frame-text">Simple UI for ease of use</p>
          </div>
          <div className="frame-content pd-left">
            <img src={TickDot} alt="point" className="tick-dot" />
            <p className="frame-text">Consumer Insights</p>
          </div>
        </Col>
        <Col md={6} className="right-image">
          <img src={Frame2} alt={"Frame1"} className="frame-img" />
        </Col>
      </Row>
      <Row className="frame-row">
        <Col md={6}>
          <img src={Frame3} alt={"Frame1"} className="frame-img" />
        </Col>
        <Col md={6} className="frame-text-col mg-40">
          <div className="frame-header">Market Analytics</div>
          <div className="frame-content pd-right">
            <img src={TickDot} alt="point" className="tick-dot" />
            <p className="frame-text">Who visited?</p>
          </div>
          <div className="frame-content pd-right">
            <img src={TickDot} alt="point" className="tick-dot" />
            <p className="frame-text">What did they review?</p>
          </div>
          <div className="frame-content pd-right">
            <img src={TickDot} alt="point" className="tick-dot" />
            <p className="frame-text">Better Booking Conversations</p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ImageSideIQComponent;
